import { ActionTree } from 'vuex';
import { ProfileState } from './types';
import { mutations } from './mutations';
import { RootState } from '../../types';
import { loginApi, logoutApi, getUserInfoApi  } from '@/api/module/login/login'
import { setToken, removeToken, getToken } from '@/utils/auth'

interface UserInfo {
    p: string;
    u: string;
}

// dispatch 当操作中含有异步操作（请求）
// commit 同步操作使用

export const actions: ActionTree<ProfileState, RootState> = {
    LoginByUsername({ commit }: any, userInfo: UserInfo) {
        const username = userInfo.u.trim()
        return new Promise((resolve, reject) => {
            loginApi(username, userInfo.p)
                .then((response: any) => {
                    const data = response;
                    // 向 vuex mutations
                    // commit("SetInit");

                    setToken(data.id);
                    resolve(data)
                }).catch((error: any) => {
                    console.log("LoginByUsername error",error);
                    reject(error)
                })
        })
    },


    // 获取用户信息 
    GetUserInfo({ commit, dispatch, state }: any) {
        if (!state.isInit) {
            return new Promise((resolve, reject) => {
                getUserInfoApi().then((response: any) => {
                    console.log("[VUEX] 获取用户信息成功");
                    console.log("getUserInfo",response);
                    let username = response.username;
                    let roleid = response.roleid;
                    // let type = response.type;
                    let id = response.id;
                    let isadmin = response.isadmin;
                    
                    commit("SetUser",response);

                    commit("SetId", id);
                    commit("SetUsername", username);
                    // commit("SetInit");
                    commit("SetIsAdmin", isadmin);
                    if (!isadmin) {
                        commit("SetRoleName",response.rolename);
                        commit("SetRoleId",roleid);
                        //党组织管理员
                        if(roleid == "00002"){
                            commit("SetPartyOrgName",response.partyorg);
                        }

                        //单位管理员
                        if(roleid == "00003"){
                            commit("SetCompanyName",response.unit);
                        }

                        let roleObj:any = new Object;
                        let powerId = [];
                        for (let i = 0; i < response.permissions.length; i++) {
                            powerId.push(response.permissions[i].id)
                        }
                        for (let i = 0; i < powerId.length; i++) {
                            let oneItem = `hasPer${powerId[i]}`
                            roleObj[oneItem] = true;
                        }
                        commit("SetRoleInfo", roleObj);
                    }
                    // 根据 type 设置权限
                    resolve(response)
                }).catch((error: any) => {
                    reject(error)
                })
            })
        } else {
            return new Promise((resolve, reject) => {
                resolve();
            })
        }
    },

    // 登出
    LogOut({ commit, state, dispatch }: any) {
        return new Promise((resolve, reject) => {
            logoutApi().then(() => {
                // 清理 vuex 信息
                commit('clear')
                // 清除权限信息
                // dispatch(mutations.ClearPermissions);

                // 移除 cookie
                removeToken()
                resolve()
            }).catch((error: any) => {
                reject(error)
            })
        })
    },

    // // 动态修改权限
    // ChangeRoles({ commit, dispatch }: any, role: any) {
    //   return new Promise(resolve => {
    //     commit('SET_TOKEN', role)
    //     setToken(role)
    //     getUserInfo(role).then((response: { data: any; }) => {
    //       const data = response.data
    //       commit('SET_ROLES', data.roles)
    //       commit('SET_NAME', data.name)
    //       commit('SET_AVATAR', data.avatar)
    //       commit('SET_INTRODUCTION', data.introduction)
    //       dispatch('GenerateRoutes', data) // 动态修改权限后 重绘侧边菜单
    //       resolve()
    //     })
    //   })
    // }
};